import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIClickable from 'UIComponents/button/UIClickable';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import UITruncateString from 'UIComponents/text/UITruncateString';
import HistoryPanelHeaderWithLink from 'automation-ui-canvas/containers/enrollment-history/panel/HistoryPanelHeaderWithLink';
import CurrentRevisionDateTime from 'automation-ui-canvas/containers/enrollment-history/panel/selected-enrollment/CurrentRevisionDateTime';
import EnrollmentSelect from 'automation-ui-canvas/containers/enrollment-history/panel/selected-enrollment/EnrollmentSelect';
import { getEnrollmentHistoryListUrl } from 'automation-ui-canvas/utils/urls';
import { getIsObjectlessFlow } from 'automation-ui-flow-core/flow/flowUtils';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import ViewRecordLink from 'flow-doctor-lib/components/diagnosis/ViewRecordLink';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { View } from 'foundations-components/transitional/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentInfoRow = ({
  label,
  content
}) => {
  return /*#__PURE__*/_jsxs(Grid, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: 4,
      children: /*#__PURE__*/_jsx(Small, {
        weight: "bold",
        children: label
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      size: 8,
      alignSelf: "end",
      children: /*#__PURE__*/_jsx(Small, {
        children: content
      })
    })]
  });
};
const SelectedEnrollmentHeader = ({
  enrollmentLogEvent,
  flow,
  isHybrid
}) => {
  const {
    search
  } = useLocation();
  const history = useHistory();
  const trackEvent = useTrackEvent();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const handleChangeEnrollment = () => {
    searchParams.delete('enrollmentId');
    searchParams.delete('logEventKey');
    history.replace({
      pathname: getEnrollmentHistoryListUrl({
        flowId: flow.flowId
      }),
      search: searchParams.toString()
    });
    trackEvent(Trackables.PERFORMANCE_HISTORY_CLICKED_CHANGE_ENROLLMENT);
  };
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-tertiary-default",
    paddingBlockStart: "600",
    children: /*#__PURE__*/_jsxs(PanelSection, {
      marginBlockEnd: "0",
      paddingInline: "500",
      children: [/*#__PURE__*/_jsx(HistoryPanelHeaderWithLink, {
        titleKey: "automation.enrollmentHistory.panel.selected-enrollment.header.title",
        navigationLinkKey: "automation.enrollmentHistory.panel.selected-enrollment.header.navigationLink",
        navigationLinkClickHandler: handleChangeEnrollment,
        navigationDirection: "left"
      }), /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(View, {
          inlineSize: "450px",
          marginInline: "100",
          children: /*#__PURE__*/_jsx(EnrollmentSelect, {
            flowId: flow.flowId,
            flowObjectTypeId: flow.objectTypeId,
            isHybrid: isHybrid,
            currentEnrollmentLogEvent: enrollmentLogEvent
          })
        }), /*#__PURE__*/_jsxs(UIList, {
          className: "m-bottom-3 p-x-1",
          children: [/*#__PURE__*/_jsx(EnrollmentInfoRow, {
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentHistory.panel.selected-enrollment.enrolledOnLabel"
            }),
            content: /*#__PURE__*/_jsx(FormattedDateTime, {
              value: enrollmentLogEvent.timestamp,
              format: "lll z",
              type: "portalTz"
            })
          }), /*#__PURE__*/_jsx(EnrollmentInfoRow, {
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentHistory.panel.selected-enrollment.workflowVersionLabel"
            }),
            content: /*#__PURE__*/_jsx(CurrentRevisionDateTime, {
              flowId: flow.flowId,
              timestamp: enrollmentLogEvent.timestamp,
              format: "lll z"
            })
          }), !getIsObjectlessFlow(flow) && /*#__PURE__*/_jsx(EnrollmentInfoRow, {
            label: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              baseLangKey: "automation.enrollmentHistory.panel.selected-enrollment.objectInfoLabel_cob",
              objectTypeId: flow.objectTypeId
            }),
            content: /*#__PURE__*/_jsx(UITruncateString, {
              children: /*#__PURE__*/_jsx(UIClickable, {
                onClick: () => trackEvent(Trackables.PERFORMANCE_HISTORY_CLICK_VIEW_IN_CRM_LINK),
                style: {
                  width: '100px'
                },
                children: /*#__PURE__*/_jsx(ViewRecordLink, {
                  enrollmentEvent: enrollmentLogEvent
                })
              })
            })
          })]
        })]
      })]
    })
  });
};
export default SelectedEnrollmentHeader;